import React from 'react';
import { Box, Typography } from '@mui/material';
import { buildDocumentFacts } from '../utils/drawerDocumentFacts';

type Props = Parameters<typeof buildDocumentFacts>[0] & { showEvidence?: boolean };

export default function DrawerDocumentFacts({ showEvidence = false, ...input }: Props) {
    const facts = buildDocumentFacts(input);
    if (!facts.length) return null;
    return (
        <Box component="dl" data-testid="WB_DOCUMENT_FACTS" sx={{ m: 0, display: 'grid', gap: 1.5 }}>
            {facts.map((fact) => (
                <Box key={fact.key}>
                    <Typography component="dt" variant="caption" sx={{ color: 'var(--color-text-secondary)' }}>{fact.label}</Typography>
                    <Typography component="dd" variant="body2" sx={{ m: 0, fontWeight: 600, color: 'var(--color-text-primary)', overflowWrap: 'anywhere' }}>{fact.value}</Typography>
                    {showEvidence && fact.evidence && (
                        <Typography component="dd" variant="body2" sx={{ m: 0, mt: 0.5, color: 'var(--color-text-secondary)' }}>{fact.evidence}</Typography>
                    )}
                </Box>
            ))}
        </Box>
    );
}
